import axios from 'axios'
import { config } from '@/config.js'

const baseUrl = config.external.clusterSvcUrl

export async function submitClusterJob(jobDetails, clusterData) {
    const jobResult = await axios.post(`${baseUrl}/cluster/jobs`, jobDetails)

    if (![200, 201].includes(jobResult.status)) {
        throw new Error(
            `Cluster svc returned non 200 status code for job submit: ${jobResult.status}`
        )
    }

    const uploadUrl = jobResult.data.data_upload_url

    const cleanAxios = axios.create()
    const uploadResult = await cleanAxios.put(uploadUrl, clusterData)

    if (![200, 201].includes(jobResult.status)) {
        throw new Error(
            `Uploading cluster job data returned non 200 status code for data upload: ${uploadResult.status}`
        )
    }

    return jobResult.data.job_id
}

export async function getJobStatus(jobId) {
    return await axios.get(`${baseUrl}/cluster/jobs/${jobId}/status`)
}
